<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/rebate',title:'信贷管理'},{title:'信贷比对（外销）'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox zhi">
                    <el-form :inline="true" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item style="width: 15%;">
								<el-switch
										v-model="formInline.chayiflag"
										active-text="有差异"
										inactive-text="全部">
								</el-switch>
							</el-form-item>
							<el-form-item label="经销商编码">
							    <el-input v-model="formInline.usercode" placeholder=""></el-input>
							</el-form-item>
							<el-form-item label="经销商名称">
							    <el-input v-model="formInline.username" placeholder=""></el-input>
							</el-form-item>
							<el-form-item label="公司代码">
							    <el-input v-model="formInline.kkber" placeholder=""></el-input>
							</el-form-item>
						</div>
                    </el-form>
					<div class="l-screenBox">
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="getCreditComparePage">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resectData">重置</el-button>
							<el-button class="h-btn h-formBtn" @click="synSapCredit">同步SAP信贷</el-button>
						</div>
					</div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <div style="background:#fff;width:100%;">
                        <el-table
                                ref="multipleTable"
                                :data="tableData2"
                                stripe
                                border
                                style="width: 100%"
								max-height="510"

                        >
                            <el-table-column
                                    type="selection"
                                    width="45"
                                    label="全选"
                                    fixed
                            >
                            </el-table-column>
                            <el-table-column
                                    type="index"
                                    width="45"
                                    label="#"
                                    fixed>
                            </el-table-column>
                            <el-table-column
                                    prop="usercode"
                                    label="经销商编码"
                            		:show-overflow-tooltip="true"
                                    width="120">
                            </el-table-column>
                            <el-table-column
                                    prop="username"
                                    label="经销商名称"
                            		:show-overflow-tooltip="true"
                                    min-width="180">
                            		<template slot-scope="scope">
                            			<div style="text-align: left;">
                            				{{scope.row.username}}
                            			</div>
                            		</template>
                            </el-table-column>
                            <el-table-column
                                    prop="kkber"
                                    label="公司代码"
                                    :show-overflow-tooltip="true"
                                    width="90">
                            </el-table-column>
                            <el-table-column
                                    prop="klimk"
                                    label="SAP限额"
                                    :show-overflow-tooltip="true"
                                    width="90">
                            		<template slot-scope="scope">
                            			<div style="text-align: right;">
                            				{{scope.row.klimk}}
                            			</div>
                            		</template>
                            </el-table-column>
                            <el-table-column
                                    prop="oblig"
                                    label="SAP风险总额"
                                    :show-overflow-tooltip="true"
                                    width="120">
                            		<template slot-scope="scope">
                            			<div style="text-align: right;">
                            				{{scope.row.oblig}}
                            			</div>
                            		</template>
                            </el-table-column>
                            <el-table-column
                                    prop="sapyue"
                                    :show-overflow-tooltip="true"
                                    label="SAP余额"
                                    width="90">
                            		<template slot-scope="scope">
                            			<div style="text-align: right;">
                            				{{scope.row.sapyue}}
                            			</div>
                            		</template>
                            </el-table-column>
                            <el-table-column
                                    prop="totalCredit"
                                    label="OMS限额"
                                    :show-overflow-tooltip="true"
                                    width="100">
                            		<template slot-scope="scope">
                            			<div style="text-align: right;">
                            				{{scope.row.totalCredit}}
                            			</div>
                            		</template>
                            </el-table-column>
                            <el-table-column
                                    prop="cashBalance"
                                    label="OMS现金余额"
                                    :show-overflow-tooltip="true"
                                    width="130">
                            		<template slot-scope="scope">
                            			<div style="text-align: right;">
                            				{{scope.row.cashBalance}}
                            			</div>
                            		</template>
                            </el-table-column>
                            <el-table-column
                                    prop="creditBalance"
                                    label="OMS信贷余额"
                                    :show-overflow-tooltip="true"
                                    width="130">
                            		<template slot-scope="scope">
                            			<div style="text-align: right;">
                            				{{scope.row.creditBalance}}
                            			</div>
                            		</template>
                            </el-table-column>
                            <el-table-column
                                    prop="total"
                                    label="OMS审批中和缺款订单总额"
                                    :show-overflow-tooltip="true"
                                    width="230">
                            		<template slot-scope="scope">
                            			<div style="text-align: right;">
                            				{{scope.row.total}}
                            			</div>
                            		</template>
                            </el-table-column>
                            <el-table-column
                                    prop="total2"
                                    label="OMS审批通过订单总额"
                                    :show-overflow-tooltip="true"
                                    width="190">
                            		<template slot-scope="scope">
                            			<div style="text-align: right;">
                            				{{scope.row.total2}}
                            			</div>
                            		</template>
                            </el-table-column>
                            <el-table-column
                                    prop="owe"
                                    label="OMS逾期和作废信贷欠款"
                                    :show-overflow-tooltip="true"
                                    width="210">
                            		<template slot-scope="scope">
                            			<div style="text-align: right;">
                            				{{scope.row.owe}}
                            			</div>
                            		</template>
                            </el-table-column>
                            <el-table-column
                                    prop="omsyue"
                                    label="OMS余额"
                                    :show-overflow-tooltip="true"
                                    width="100">
                            		<template slot-scope="scope">
                            			<div style="text-align: right;">
                            				{{scope.row.omsyue}}
                            			</div>
                            		</template>
                            </el-table-column>
                            <el-table-column
                                    prop="totalcha"
                                    label="总额差额"
                                    :show-overflow-tooltip="true"
                                    width="90">
                            		<template slot-scope="scope">
                            			<div style="text-align: right;">
                            				{{scope.row.totalcha}}
                            			</div>
                            		</template>
                            </el-table-column>
                            <el-table-column
                                    prop="yuecha"
                                    label="余额差额"
                                    :show-overflow-tooltip="true"
                                    width="90">
                            		<template slot-scope="scope">
                            			<div style="text-align: right;">
                            				{{scope.row.yuecha}}
                            			</div>
                            		</template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ"
                                       icon="h-el-icon h-el-icon-import" @click="exportExeal">批量导出
                            </el-button>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="choose"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import customerLedgerService from "../../../api/loud/credit/customerLedgerService";
	import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
    import util from "../../../utils/util";
    import updownfile from "../../../utils/updownfile";
    import ss from "../../../api/SystemService";

    export default {
        data() {
            return {
                formInline: {
					chayiflag: false,
                    username: '',
                    usercode: "",
                    kkber: "",
					agentType: "3",
                    pageSize: 10,
                    pageNo: 1,
                },
                tableData2: [],
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0
                },
            }
        },
        created() {
            this.getCreditComparePage();
        },
        methods: {
            exportExeal(){
				this.$msg.confirm("确定导出？", () => {
				    updownfile.down("/api/swyl/v1/infoCredit/userInfoCredit/exportCreditCompare",this.formInline, 'post','data');
				})
            },
            // 查询信贷列表/检索按钮功能
            getCreditComparePage() {
                customerLedgerService.getCreditComparePage(this.formInline).then(res => {
                    this.tableData2 = res.records;
                    this.q.total = res.total;
                })
            },
            //重置按钮功能
            resectData() {
                this.formInline.username = "";
				this.formInline.usercode = "";
                this.formInline.kkber = "";
                this.formInline.pageNo = 1;
                this.formInline.pageSize = 10;

                this.q.pageNo = 1;
                this.q.pageSize = 10;
            },
            //分页按钮功能选择
            choose() {
                this.formInline.pageNo = this.q.pageNo;
                this.formInline.pageSize = this.q.pageSize;
                this.getCreditComparePage();
            },
			synSapCredit() {
				this.$msg.confirm("确定执行？", () => {
				    customerDetailsService.synSapCredit({"flag":2}).then(rd => {
				        this.$msg.alert("执行成功！")
				    })
				})
			},
        },
    }
</script>
<style>
    .zhi .h-formBorder .el-form-item__label {
        vertical-align: top;
    }

    .zhi .el-date-editor .el-range-separator {
        width: 9%;
        margin-bottom: 6px;
    }
</style>
